import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import teamPic from '../../../assets/images/tim_regan_dropbox-2a@2x (1).png'
import Emitter from '../../../utils/emitter';
const TeamMemberInfo = () => {
    const navigate = useNavigate();
    const handlBackBtn = () => {
        navigate('/')
        Emitter.emit("MOVE_SECTION", 4);

    }
    return (
        <section className="team-info-section ">
            <div className="container ">
                <h5 className="section-title  pb-4">    <FontAwesomeIcon icon={faChevronLeft} onClick={handlBackBtn} className="back-btn " />  TEAM ARTPARK </h5>

                <div className="row team-member-info">
                    <div className="col-md-5 ">

                        <h3 className="subtitle pt-0 pb-1">Sudhir Mor</h3>
                        <h5 className="body-text pb-4">Head Designer</h5>
                        <p className="body-text pb-2">Co-founder AI foundry, Advisor & Founding Partner pi Ventures, a $35m early stage fund for AI (India’s first & only AI focused fund). Sr. AI Advisor, Sweden India Business Council. India's nominated expert on GPAI (Global Partnership on AI ) for Innovation and commercialization.</p>

                        <div className="  linkedin-btn row g-0">
                            <span className="col-3 d-flex justify-content-center" >
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </span>

                            <div className="  col-9 d-flex justify-content-center">
                                <p className=" p-0 m-0">View Linkedin Profile</p>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-7 ">
                        {/* <div className="team-media">
                            <img src={teamPic} alt="" className="img-fluid" />

                        </div> */}

                        <div className="card bg-dark text-white">
                            <img src="..." className="card-img" alt="..."></img>
                            
                        </div>
                    </div>
                </div>



            </div>
        </section>
    );
};

export default TeamMemberInfo;